import register from '../entrypoint';
import StorefrontWidgetContainer from '../widgets/container/StorefrontWidgetContainer';

// Styles
import '../stylesheets/widgets.scss';

register({ StorefrontWidgetContainer });
